import { render, staticRenderFns } from "./ProductContentList.vue?vue&type=template&id=13356d9d&scoped=true"
import script from "./ProductContentList.vue?vue&type=script&lang=js"
export * from "./ProductContentList.vue?vue&type=script&lang=js"
import style0 from "./ProductContentList.vue?vue&type=style&index=0&id=13356d9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13356d9d",
  null
  
)

export default component.exports